const parseDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? new Date(value) : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const toCalendarTimestamp = (date) =>
  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

const ADDRESS_TYPE_VALUES = {
  Loading: 0,
  Unloading: 1,
};

const toApiAddressType = (type) =>
  typeof type === "number" ? type : ADDRESS_TYPE_VALUES[type];

export const createRouteDateRows = (addressList = []) => {
  const sortedAddresses = addressList
    .map((address, originalIndex) => ({ address, originalIndex }))
    .sort((left, right) => Number(left.address.step) - Number(right.address.step));

  return sortedAddresses.map(({ address, originalIndex }, index) => ({
    id: address.id,
    step: address.step,
    type: address.type,
    cityName: address.cityName,
    address: address.address,
    date: parseDate(address.shippingDate),
    shippingHourFrom: address.shippingHourFrom,
    shippingHourTo: address.shippingHourTo,
    originalIndex,
    isIntermediate: index > 0 && index < sortedAddresses.length - 1,
  }));
};

export const getPreviousFilledDate = (rows, index) => {
  for (let currentIndex = index - 1; currentIndex >= 0; currentIndex -= 1) {
    if (rows[currentIndex]?.date) return rows[currentIndex].date;
  }

  return null;
};

export const validateRouteDates = (rows = []) => {
  const errors = {};

  if (rows[0] && !rows[0].date) {
    errors[rows[0].id] = "required";
  }

  let previousDate = null;
  rows.forEach((row) => {
    if (!row.date) return;

    if (
      previousDate &&
      toCalendarTimestamp(row.date) < toCalendarTimestamp(previousDate)
    ) {
      errors[row.id] = "chronology";
    }

    previousDate = row.date;
  });

  return errors;
};

export const toUtcDateOnlyIso = (date) =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString();

export const buildRouteDatesPayload = (orderId, rows) => ({
  orderId,
  addressList: rows.map((row) => ({
    id: row.id,
    shippingDate: row.date ? toUtcDateOnlyIso(row.date) : null,
    shippingHourFrom: row.shippingHourFrom ?? 0,
    shippingHourTo: row.shippingHourTo ?? 0,
    type: toApiAddressType(row.type),
  })),
});
